var _path, _path2, _path3, _path4, _line, _line2, _line3, _line4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebsiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    strokeWidth: 3,
    stroke: "#737373",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.93,55.72A24.86,24.86,0,1,1,56.86,32.15a37.24,37.24,0,0,1-.73,6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.86,51.1A47,47,0,0,1,32,56.7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32,7A34.14,34.14,0,0,1,43.57,30a34.07,34.07,0,0,1,.09,4.85"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32,7A34.09,34.09,0,0,0,20.31,32.46c0,16.2,7.28,21,11.66,24.24"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10.37,
    y1: 19.9,
    x2: 53.75,
    y2: 19.9
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 6.99,
    x2: 32,
    y2: 56.7
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 11.05,
    y1: 45.48,
    x2: 37.04,
    y2: 45.48
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 7.14,
    y1: 32.46,
    x2: 56.86,
    y2: 31.85
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.57,57,58,52.56l-8-8,4.55-2.91a.38.38,0,0,0-.12-.7L39.14,37.37a.39.39,0,0,0-.46.46L42,53.41a.39.39,0,0,0,.71.13L45.57,49Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteIcon);
export default __webpack_public_path__ + "static/media/website_icon.9f032bd898f8da65999ff314f376feb8.svg";
export { ForwardRef as ReactComponent };